export default __webpack_public_path__ + "static/media/ticket.155c70e6.svg";